// extracted by mini-css-extract-plugin
module.exports = {"main-grid":"main-layout_main-grid___PzO_","content":"main-layout_content__Gfyd8"};